import React from "react";
import PropTypes from "prop-types";

import LinearProgress from "./linearProgress";
import CircularProgress from "./circularProgress";
import "./progress.scss";

const Progress = props => {
  const { value, max, type } = props;
  if (Number(value) > Number(max)) {
    throw new Error(
      `Progress value (${value}) can not be greater than max (${max})`
    );
  }

  let Tag = LinearProgress;
  if (type === "circular") {
    Tag = CircularProgress;
  }

  return <Tag {...props} />;
};

Progress.propTypes = {
  type: PropTypes.oneOf(["linear", "circular"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  indeterminate: PropTypes.bool,
  animate: PropTypes.bool,
  showPercProgress: PropTypes.bool,
  renderPercProgress: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelPlacement: PropTypes.oneOf(["right", "bottom"]),
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

Progress.defaultProps = {
  type: "linear",
  size: "md",
  value: 0,
  max: 100,
  indeterminate: false,
  animate: false,
  showPercProgress: true,
  label: null,
  labelPlacement: "bottom",
  dataTestId: "orion-progress-bar"
};

Progress.displayName = "OrionProgress";

export default Progress;
